import { render } from "./DocumentIcon.vue?vue&type=template&id=7042d8fe"
import script from "./DocumentIcon.vue?vue&type=script&lang=js"
export * from "./DocumentIcon.vue?vue&type=script&lang=js"

import "./DocumentIcon.vue?vue&type=style&index=0&id=7042d8fe&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__